import { useToast } from '@alpine-iq/ui-library'

type ToastOptions = {
  message: string
  type: 'success' | 'danger' | 'info' | 'warning'
  toastKey?: string
}

// Global toaster instance that can be used outside of React components
// This relies on the App component initializing it via useToasterAPI
export const toaster = {
  addToast: (options: ToastOptions) => {
    console.log('[Toaster fallback]', options)
  },
}

export function setToasterInstance(instance: ReturnType<typeof useToast>) {
  toaster.addToast = (options: ToastOptions) => {
    instance.addToast({
      message: options.message,
      type: options.type,
      toastKey: options.toastKey,
    })
  }
}

export function showErrorToast(message: string) {
  toaster.addToast({
    message,
    type: 'danger',
  })
  return undefined
}

export function showSuccessToast(message: string) {
  toaster.addToast({
    message,
    type: 'success',
  })
  return undefined
}

export function showInfoToast(message: string) {
  toaster.addToast({
    message,
    type: 'info',
  })
  return undefined
}
